'use client';

import { CommonImage } from "@/components/common";
import { setSearchPopup } from '@/redux/actions/common.action';
import { AppDispatch } from '@/redux/store';
import { format } from 'date-fns';
import { enIN } from 'date-fns/locale';
import Link from 'next/link';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SearchResultSkeleton } from './components';
import useSearchList from './hooks/useSearchList.hook';

export default function SearchList({ queryString }: { queryString: string }) {  
  const { data, loading, hasMore, loadMore, refreshing } = useSearchList(queryString);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const handleScroll = () => {
      if (
        window?.innerHeight + document.documentElement.scrollTop + 100 >=
        document.documentElement.scrollHeight
      ) {
        if (!loading && hasMore) {
          loadMore();
        }
      }
    };

    window?.addEventListener('scroll', handleScroll);
    return () => window?.removeEventListener('scroll', handleScroll);
  }, [loading, hasMore, loadMore]);

  if (loading && !data.length) {
    return (
      <div className='px-6 grid grid-cols-1 gap-4 md:grid-cols-2'>
        <SearchResultSkeleton />
        <SearchResultSkeleton />
        <SearchResultSkeleton />
        <SearchResultSkeleton />
      </div>
    );
  }

  return (
    <>
      <div className="w-full px-6 overflow-y-auto grid grid-cols-1 gap-4 md:grid-cols-2">
        {data?.length > 0 ?
          data?.map((item: any, idx: number) => {
            const { isRecurringEvent, eventDate, dateString } = item;

            return (
              <Link
                key={idx}
                href={`/${item.eventCode}`}
                className="flex cursor-pointer gap-4 rounded-xl text-sm font-bold text-zinc-700"
                onClick={() => dispatch(setSearchPopup(false))}
              >
                <CommonImage
                  src={item?.poster?.[0]?.url}
                  alt="eventImg"
                  width={130}
                  height={80}
                  className="rounded-xl shrink-0 h-[80px] w-[130px]"
                />
                <div>
                  <p className='text-wrap'>{item.name}</p>
                  <p className="text-xs text-wrap text-zinc-500">
                    {!isRecurringEvent && eventDate ? format(isNaN(Number(eventDate)) ? eventDate : Number(eventDate), "EEE d LLL yyyy", { locale: enIN }) : dateString}
                  </p>
                </div>
              </Link>
            )
          }) : <p className="w-full col-span-2 text-center py-3 text-zinc-500">No results found</p>}
      </div>
      {refreshing && <p className="text-center py-3">Loading more...</p>}
    </>
  );
}
